import { Dispatch, memo, SetStateAction, useMemo } from "react";
import { Task } from "..";
import { COFFRET } from "../../api/coffrets";
import "./style.scss";

type PropsType = {
  filteredCoffrets: COFFRET[];
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  pageSize?: number; // défaut 60
};

const TasksList = ({ filteredCoffrets, page, setPage, pageSize = 60 }: PropsType) => {
  const len = Array.isArray(filteredCoffrets) ? filteredCoffrets.length : 0;

  const totalPages = Math.max(1, Math.ceil(len / pageSize));
  const current = Math.min(Math.max(1, page), totalPages);

  const pageSlice = useMemo(() => {
    const start = (current - 1) * pageSize;
    return filteredCoffrets.slice(start, start + pageSize);
  }, [filteredCoffrets, current, pageSize]);

  const goto = (p: number) => setPage(Math.min(Math.max(1, p), totalPages));

  return (
    <>
      <div className="collection-number">
        {len} Spécimen{len > 1 ? "s" : ""}
      </div>

      {/* Pagination top */}
      <div className="pagination">
        <button onClick={() => goto(1)} disabled={current === 1}>
          «
        </button>
        <button onClick={() => goto(current - 1)} disabled={current === 1}>
          ‹
        </button>
        <span className="page-info">
          Page {current} / {totalPages}
        </span>
        <button onClick={() => goto(current + 1)} disabled={current === totalPages}>
          ›
        </button>
        <button onClick={() => goto(totalPages)} disabled={current === totalPages}>
          »
        </button>
      </div>

      <ul className="tasks-list">
        {pageSlice.map((coffret) => (
          <Task key={String(coffret._id)} coffret={coffret} />
        ))}
      </ul>

      {/* Pagination bottom */}
      <div className="pagination">
        <button onClick={() => goto(1)} disabled={current === 1}>
          «
        </button>
        <button onClick={() => goto(current - 1)} disabled={current === 1}>
          ‹
        </button>
        <span className="page-info">
          Page {current} / {totalPages}
        </span>
        <button onClick={() => goto(current + 1)} disabled={current === totalPages}>
          ›
        </button>
        <button onClick={() => goto(totalPages)} disabled={current === totalPages}>
          »
        </button>
      </div>
    </>
  );
};

export const MemoizedTasksList=memo(TasksList);